var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"w54dC5tm0eUV7OKGz8EK9"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["gsu-web@getsetup-inc"]={id:"w54dC5tm0eUV7OKGz8EK9"};
      